import { getCookie, setCookie } from '@beef/utils';
export var EUserAuth;
(function (EUserAuth) {
  EUserAuth["Mobile"] = "Mobile";
  EUserAuth["Convergent"] = "Convergent";
  EUserAuth["Home"] = "Home";
  EUserAuth["Unknown"] = "Unknown";
  EUserAuth["Ported"] = "Ported";
})(EUserAuth || (EUserAuth = {}));
export var getAccountType = function getAccountType(userAuth) {
  if (!userAuth || !('isAuthorized' in userAuth)) {
    return 'none';
  }
  switch (userAuth.userType) {
    case EUserAuth.Mobile:
      return 'mobile';
    case EUserAuth.Home:
      return 'fttb';
    case EUserAuth.Convergent:
      return 'fmc';
    default:
      return 'none';
  }
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
var DigiAPI = function DigiAPI() {
  var _window$Digi;
  return typeof window !== 'undefined' ? ((_window$Digi = window.Digi) === null || _window$Digi === void 0 ? void 0 : _window$Digi.api) || {} : {};
};
export var EDIGI;
(function (EDIGI) {
  EDIGI["tap"] = "tap";
  EDIGI["history"] = "history";
  EDIGI["popular"] = "popular";
  EDIGI["product"] = "product";
})(EDIGI || (EDIGI = {}));
var CLICK_TYPE = {
  tap: 'sendAutocompleteTapClickEvent',
  history: 'sendAutocompleteHistoryClickEvent',
  popular: 'sendAutocompleteQueryClickEvent',
  product: 'sendAutocompleteProductClickEvent'
};
export var methodsDigi = {
  sendSearchEvent: function sendSearchEvent(data) {
    var _DigiAPI$sendSearchEv, _DigiAPI, _data$tariffs, _data$taps;
    return (_DigiAPI$sendSearchEv = (_DigiAPI = DigiAPI()).sendSearchEvent) === null || _DigiAPI$sendSearchEv === void 0 ? void 0 : _DigiAPI$sendSearchEv.call(_DigiAPI, {
      searchTerm: data.query,
      correction: data.correction,
      pageProducts: (_data$tariffs = data.tariffs) === null || _data$tariffs === void 0 ? void 0 : _data$tariffs.concat(data.products).map(function (product) {
        return product.id;
      }),
      refinements: (_data$taps = data.taps) === null || _data$taps === void 0 ? void 0 : _data$taps.map(function (tap) {
        return tap.label;
      })
    });
  },
  sendClickEvent: function sendClickEvent(_ref) {
    var _DigiAPI$CLICK_TYPE$t, _DigiAPI2;
    var query = _ref.query,
      correction = _ref.correction,
      item = _ref.item,
      type = _ref.type;
    return (_DigiAPI$CLICK_TYPE$t = (_DigiAPI2 = DigiAPI())[CLICK_TYPE[type]]) === null || _DigiAPI$CLICK_TYPE$t === void 0 ? void 0 : _DigiAPI$CLICK_TYPE$t.call(_DigiAPI2, {
      searchTerm: query,
      correction: correction,
      item: item
    });
  },
  sendProductsClickEvent: function sendProductsClickEvent(_ref2) {
    var _DigiAPI$CLICK_TYPE$p, _DigiAPI3;
    var query = _ref2.query,
      correction = _ref2.correction,
      item = _ref2.item,
      productId = _ref2.productId;
    return (_DigiAPI$CLICK_TYPE$p = (_DigiAPI3 = DigiAPI())[CLICK_TYPE.product]) === null || _DigiAPI$CLICK_TYPE$p === void 0 ? void 0 : _DigiAPI$CLICK_TYPE$p.call(_DigiAPI3, {
      searchTerm: query,
      correction: correction,
      item: item,
      productId: productId
    });
  }
};
export var CASH_SEARCH_COOKIE_NAME = 'searchAnalyticsCash';

/**
 * Сохранение в куки историю переходов по результатам запроса, в рамках одного текущего запроса.
 * Удаление куки происходит:
 *   1) истечение времени жизни куки 12 часов,
 *   2) выполнение поискового запроса {@link ActionSearch.fetchSearchData}
 *
 * @return {boolean} - флаг - является ли вторичным переходом
 */
export var getIsSecondaryTransitionCookie = function getIsSecondaryTransitionCookie() {
  var isSecondaryTransition = !!getCookie(CASH_SEARCH_COOKIE_NAME);
  if (!isSecondaryTransition) {
    setCookie({
      name: CASH_SEARCH_COOKIE_NAME,
      value: 1,
      maxAge: 43200 // 12h,
    });
  }

  return isSecondaryTransition;
};